module.exports = __webpack_public_path__ + "static/media/freshly-grown.897e3a6d.png";